import React from 'react';
import UserAvatar from '../../lib/UserAvatar';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };
const font = "'DM Sans', sans-serif";
const TIPO_EMOJI = { comida:'🍽️', ropa:'👗', servicios:'🔧', tecnologia:'💻', artesanias:'🎨', belleza:'💅', fitness:'💪', eventos:'🎉', otro:'⭐' };

export default function ClientCard({ client, onClick, pendingCount, t }) {
  const timeAgo = (date) => {
    if (!date) return 'Sin acceso';
    const d = Math.floor((Date.now() - new Date(date)) / 86400000);
    if (d === 0) return 'Hoy';
    if (d === 1) return 'Ayer';
    if (d < 7) return `Hace ${d} días`;
    return `Hace ${Math.floor(d / 7)} semanas`;
  };

  return (
    <div onClick={onClick} style={{
      background: t.card, border: `0.5px solid ${t.border}`, borderRadius: 16,
      padding: '16px 18px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14,
      transition: 'transform 0.2s, box-shadow 0.2s',
    }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = `0 8px 24px ${C.turquesa}12`; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <UserAvatar url={client.avatar_url} name={client.full_name} size={48} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>{client.business_name || client.full_name || 'Sin nombre'}</p>
        <p style={{ fontSize: 12, color: t.textSecondary, margin: '2px 0 0' }}>
          {TIPO_EMOJI[client.business_type] || '⭐'} {client.business_type || 'Sin tipo'} · {client.city || ''}
        </p>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <p style={{ fontSize: 11, color: t.textSecondary, margin: 0 }}>{timeAgo(client.last_seen)}</p>
        {pendingCount > 0 && (
          <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: C.mango + '20', color: C.mango, fontWeight: 600 }}>{pendingCount} pendientes</span>
        )}
      </div>
    </div>
  );
}
